import firebase from 'firebase/compat/app';
import withoutNulls from '../api/search/withoutNulls';
import STORE_CONSTANTS from './constants';

const chartPaletteConverter = {
  toFirestore(
    palette: ChartPalettes.AccountPalette,
  ): firebase.firestore.DocumentData {
    return withoutNulls({ ...palette });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<ChartPalettes.AccountPalette>,
    options: firebase.firestore.SnapshotOptions,
  ): ChartPalettes.AccountPalette {
    return snapshot.data(options);
  },
};

// The account's own chart palettes (see chartPalette)
const getChartPalettesRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CHART_PALETTES_COLLECTION)
    .withConverter(chartPaletteConverter);
};

export default getChartPalettesRef;
